<template lang="jade">
div
  //- div.Tag(v-for="item in collection")
  //-   div.Tag__line {{ item | tagline }}
  //-   div.Tag__action(@click="edit($index)")
  div.Message.Message--info
    i.fa.fa-info(style="margin-right: 15px")
    span.Message__body Dependent children are covered for free at the same level as the policyholder or partner, whichever is the highest level. 
  component(v-for="input in fdata.templates"
            ":is"="input.type"
            ":fdata"="input")
  div.Button-group
    button.Button(type="button"
                  class="Button--secondary"
                  skin="sovereign"
                  @click="destroy")
      span.Button__text Remove
    button.Button(type="button"
                  class="Button--primary"
                  skin="sovereign"
                  @click="confirm")
      span.Button__text Confirm
</template>

<script>
import {forms} from 'src/vuex/getters'
import {addNotification} from 'src/vuex/actions'
import Moment from 'moment'

export default {
  data () {
    return {
      uid: this.$parent.uid,
      pid: this.$parent.identity,
      collection: [],
      cid: false,
      mandatory: true,
      formData: {}
    }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  vuex: {
    getters: {
      forms
    },
    actions: {
      addNotification
    }
  },
  filters: {
    tagline (data) {
      let props = _.map(this.keys, idx => data[idx])
      // .map(xs => _.capitalize(xs.toLowerCase()))
      let name = _.take(props, 3).join(' ')
      let date = Moment(_.last(props)).format('DD/MM/YYYY')
      // let level = parseInt(this.form.data['W.CMS.SINGLE.A.FIELD1'])
      // return name + ' - ' + date + ' - LEVEL ' + level + ' - FREE'
      return name + ' - ' + date + ' - FREE'
    }
  },
  computed: {
    keys () {
      return _.map(this.fdata.templates, xs => xs.field)
    },
    required () {
      return _.size(_.omitBy(this.formData, x => !x)) !== _.size(this.keys)
    },
    form () {
      return _.find(this.forms, ['uid', this.uid])
    }
  },
  watch: {
    'collection' () {
      this.$dispatch('fdata::tags', this.collection)
    }
  },
  events: {
    // collect data from form fields
    'fdata::input' (input) {
      this.formData = Object.assign({}, this.formData, input)
    },
    'force::submit' () {
      let vals = _.filter(_.values(this.formData), x => x)
      if (this.keys.length === vals.length) {
        this.confirm()
        this.$parent.show = true
      }
    },
    'fdata::edit': 'edit'
  },
  methods: {
    confirm () {
      this.cid !== false ? this.update(this.cid) : this.create()
    },

    edit (id) {
      this.$set('cid', id)
      this.$set('formData', this.collection[id])
      this.$broadcast('set', this.collection[id])
    },

    create () {
      if (_.find(this.collection, this.formData)) {
        this.addNotification({type: 'error',
                              msg: ['No duplicates allowed'],
                              id: _.uniqueId(),
                              timeout: 5000,
                              onComplete: 'remove',
                              show: true})
        return false
      }
      if (this.required) {
        this.fdata.templates.forEach(xs => {
          if (_.isEmpty(this.formData[xs.field])) {
            this.$broadcast('external::error', {[xs.field]: true})
            this.addNotification({type: 'error',
                                  msg: [`Please provide your child’s ${xs.label.toLowerCase()}`],
                                  id: _.uniqueId(),
                                  timeout: 5000,
                                  onComplete: 'remove',
                                  show: true})
          } else {
            this.$broadcast('external::error', {[xs.field]: null})
          }
        })
        return false
      }
      this.collection.push(this.formData)
      this.reset()
      this.push(this.collection)
    },

    update (id) {
      this.collection.splice(id, 1, this.formData)
      this.reset()
      this.push(this.collection)
    },

    destroy (id) {
      if (this.cid !== false) {
        this.collection.splice(this.cid, 1)
        this.reset()
        this.push(this.collection)
      }
    },

    push (data) {
      let values = _.map(this.keys, idx => _.map(data, xs => xs[idx]))
      this.$dispatch('fdata::group', _.zipObject(this.keys, values))
    },

    reset () {
      this.$dispatch('collapse', true)
      this.$broadcast('clear')
      this.clearErrors()
      this.$set('cid', false)
      this.$set('formData', {})
    },
    clearErrors () {
      let {templates} = this.fdata
      _.forEach(templates, xs => {
        this.$broadcast('external::error', {[xs.field]: null})
      })
    }
  },
  ready () {
    let data = _.mapValues(this.formData, (v, k) => this.form.data[k])
    let vals = _.values(data)
    if (!_.some(vals, x => !_.isEmpty(x))) {
      data = _.mapValues(this.fdata.data, xs => _.map(xs, x => x.value))
      vals = _.values(data)
    }

    if (_.some(vals, x => !_.isEmpty(x))) {
      this.$dispatch('fdata::group', data)
      _.times(vals[0].length, n => {
        this.collection.push(_.mapValues(data, x => x[n]))
      })
      this.$parent.show = true
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// multipart.vue?48fa0e38